
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/online-risks",
      function () {
        return require("private-next-pages/stories/online-risks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/online-risks"])
      });
    }
  